import React, { memo } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'primereact/button'

import { Pool, usePoolUpdateMutation } from '../../../common/redux/api/web-api'
import { notifyError } from '../../../common/features/notificationsManager/Notify'
import { Input } from '../../../common/uikit/Input'
import useText from '../../../common/hooks/useText'

export type PoolDetailsWidget = {
    save: () => void
    poolValue?: Pool
    poolName?: string | null
}

type PoolDetailsFormValues = {
    name: string
}

export const PoolDetailsWidget = memo(function PoolDetailsWidget({
    save,
    poolValue,
    poolName,
}: PoolDetailsWidget): React.ReactElement {
    const text = useText()
    const [editPool] = usePoolUpdateMutation()

    const {
        register,
        handleSubmit,
        formState: { isDirty, isValid, errors },
    } = useForm<PoolDetailsFormValues>({
        mode: 'all',
        values: { name: poolName ?? poolValue?.name ?? '' },
    })

    const onSubmit = async (data: PoolDetailsFormValues) => {
        if (!poolValue) return

        try {
            await editPool({
                pool: { ...poolValue, name: data.name },
            }).unwrap()

            save()
        } catch (e) {
            notifyError(text('msgPoolNotUpdated'))
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Input
                {...register('name', { required: text('msgNameRequired') })}
                id="input-name"
                data-testid="name-input"
                label={text('lblName')}
                autoComplete="off"
                required
                error={errors.name?.message}
            />
            <div className="flex justify-content-end mt-4">
                <Button
                    type="submit"
                    data-testid="save-btn"
                    label={text('btnSave')}
                    icon="pi pi-save"
                    disabled={!poolValue || !isValid || !isDirty}
                />
            </div>
        </form>
    )
})
